import { ChangeEvent, FC, Fragment, useCallback } from "react";
import Stack from "@mui/material/Stack";
import { Box, Button, TextField } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

interface CsvDownloadDialogToolbarProps {
  search: string;
  onSearchChange(value: string): void;
  onUnselectAllClickHandler(): void;
  isAllSelected: boolean;
  isSomeSelected: boolean;
}

export const CsvDownloadDialogToolbar: FC<CsvDownloadDialogToolbarProps> = ({
  search,
  onSearchChange,
  onUnselectAllClickHandler,
  isAllSelected,
  isSomeSelected,
}) => {
  const searchChangeHandler = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onSearchChange(event.target.value);
    },
    [onSearchChange],
  );

  return (
    <Box p={1.5} pb={0}>
      <Stack
        p={1}
        direction="row"
        borderRadius={2}
        bgcolor="grey.100"
        alignItems="center"
        justifyContent="space-between"
      >
        <Button
          onClick={onUnselectAllClickHandler}
          sx={{ bgcolor: "white", px: 1.25 }}
          startIcon={
            <Fragment>
              {isAllSelected && <CheckBoxIcon fontSize="small" />}

              {isSomeSelected && <IndeterminateCheckBoxIcon fontSize="small" />}

              {!isAllSelected && !isSomeSelected && (
                <CheckBoxOutlineBlankIcon fontSize="small" />
              )}
            </Fragment>
          }
        >
          Select All
        </Button>

        <TextField
          size="xsmall"
          sx={{ bgcolor: "white" }}
          placeholder="Search"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          value={search}
          onChange={searchChangeHandler}
        />
      </Stack>
    </Box>
  );
};
